import { Component, Input, ViewChild } from '@angular/core';
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { FormGroupComponent } from '@tecalisdev/infinity';

import { IFormFieldPreset } from '../form-field-presets';
import { FormStepCompositeFieldsPreviewComponent } from './form-step-composite-fields-preview.component';
import { FormStepInstructionsComponent } from './form-step-instructions.component';

@Component({
	selector: 'app-form-step-locked-preset-config',
	imports: [
		ReactiveFormsModule,
		TranslatePipe,
		FormGroupComponent,
		FormStepInstructionsComponent,
		FormStepCompositeFieldsPreviewComponent,
	],
	templateUrl: './form-step-locked-preset-config.component.html',
	styleUrl: './form-step-locked-preset-config.component.scss',
})
export class FormStepLockedPresetConfigComponent {
	@Input({ required: true }) form!: FormGroup;
	@Input({ required: true }) preset!: IFormFieldPreset;

	@ViewChild(FormStepInstructionsComponent)
	instructions?: FormStepInstructionsComponent;

	public get showPresetFieldsPreview(): boolean {
		return Boolean(this.preset.presetFields?.length);
	}

	public get selectedStepLocaleId(): string {
		return this.instructions?.selectedStepLocaleId ?? 'es';
	}

	public get fieldsArray(): FormArray {
		return this.form.get('fields') as FormArray;
	}

	public focusLocaleValidationErrors(): void {
		this.instructions?.markLocaleFieldsTouched();
		this.instructions?.focusFirstInvalidLocaleField();
	}
}
